import { render, staticRenderFns } from "./authtwo.vue?vue&type=template&id=63338739&scoped=true&"
import script from "./authtwo.vue?vue&type=script&lang=js&"
export * from "./authtwo.vue?vue&type=script&lang=js&"
import style0 from "./authtwo.vue?vue&type=style&index=0&id=63338739&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63338739",
  null
  
)

export default component.exports